import { useTranslation } from "react-i18next";
import { ButtonType, HeadingType } from "../../enums/componentEnums";
import AppButton from "../Inputs/AppButton";
import AppHeading from "../texts/Headings";
import { useAuth0 } from "@auth0/auth0-react";
import { useSearchParams } from "react-router-dom";
function Login() {
  const { loginWithRedirect } = useAuth0();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const handleLogin = () => {
    try {
          const returnTo = searchParams.get("returnTo");
          if (returnTo) {
            localStorage.setItem("returnTo", returnTo);
          }
          loginWithRedirect();
    } catch (error) {
      console.error("Login failed:", error);
    }
  };
  return (
    <div
      style={{
        boxShadow: "0px 0px 21px 0px rgba(0, 0, 0, 0.08)",
      }}
      className="md:h-[40%] max-h-[420px] md:w-[50%] max-w-[400px] p-10 rounded-3xl bg-white flex flex-col items-center justify-center"
    >
      <AppHeading
        text={t("login.login_prompt")}
        type={HeadingType.MAIN}
        className="mb-10"
      />
      <div
        className="w-full flex flex-col"
        // onSubmit={formik.handleSubmit}
      >
        <AppButton
          type={ButtonType.PRIMARY}
          // type={formik.isValid ? ButtonType.PRIMARY : ButtonType.DISABLED}
          text={t("login.login_btn")}
          handleClick={handleLogin}
          // style={!formik.touched.password  ? "mt-5" : ""}
        />
      </div>
    </div>
  );
}

export default Login;
